var render = function render(){var _vm=this,_c=_vm._self._c;return _c('layout-login',[_c('invite-lose')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }